export const sortByOptions = {
  cadId: "externalOfficerId",
  firstName: "firstName",
  lastName: "lastName",
  middleName: "middleName",
  badgeNumber: "badge",
  title: "title",
};

export const sortOrderOptions = {
  ascending: "ascending",
  descending: "descending",
};
